<template>
  <div>
    <Layout>
        <Header>
          <div>
            <div>
              <img src="../assets/imgs/logo2.png" alt="">
              <span>注册</span>
            </div>
            <div>
              <p>已有账号，去<span @click="$router.push('login')">登录</span></p>
            </div>
          </div>
        </Header>
        <Content>
          <Card>
            <p class="title">欢迎注册中铁桥隧招标网</p>
            <Form ref="formRef" :model="form" :rules="formRules" :label-width="100">
              <FormItem label="单位名称:" prop="hzqy">
                <Input @on-blur="validateHzqy" v-model="form.hzqy" placeholder="请输入单位名称" size="large"></Input>
              </FormItem>
              <FormItem label="合作类型:" prop="types">
                <Select multiple v-model="form.types" placeholder="请输入合作类型" size="large">
                  <Option v-for="item in typeOptions" :value="item.name" :key="item.name">{{ item.value }}</Option>
                </Select>
              </FormItem>
              <FormItem label="注册地点:" prop="zcdd">
                <Input v-model="form.zcdd" placeholder="请输入注册地点" size="large"></Input>
              </FormItem>
              <FormItem label="法人代表:" prop="frdb">
                <Input v-model="form.frdb" placeholder="请输入法人代表" size="large"></Input>
              </FormItem>
              <FormItem label="联系人姓名:" prop="lxrxm">
                <Input v-model="form.lxrxm" placeholder="请输入联系人姓名" size="large"></Input>
              </FormItem>
              <FormItem label="联系人电话:" prop="lxrdh">
                <Input v-model="form.lxrdh" placeholder="请输入联系人电话" size="large"></Input>
              </FormItem>
              <FormItem label="邮箱:" prop="email">
                <Input v-model="form.email" placeholder="请输入邮箱" size="large"></Input>
              </FormItem>
              <FormItem label="开户行:" prop="khh">
                <Input v-model="form.khh" placeholder="请输入开户行" size="large"></Input>
              </FormItem>
              <FormItem label="开户行账号:">
                <Input v-model="form.khzh" placeholder="请输入开户行账号" size="large"></Input>
              </FormItem>
              <FormItem label="企业简介:" prop="qyjj">
                <Input v-model="form.qyjj" show-word-limit maxlength="260" type="textarea" :rows="4" placeholder="请输入企业简介" size="large"></Input>
              </FormItem>
              <FormItem label="申请原因:" prop="sq_yj">
                <Input v-model="form.sq_yj" show-word-limit maxlength="260" type="textarea" :rows="4" placeholder="请输入申请原因" size="large"></Input>
              </FormItem>
              <div class="divider"></div>
              <FormItem label="企业资质:">
                <UploadFile name="企业资质" :isRegister="true" ref="UploadFileRefA" v-model="form.attachment_FJA_Length"></UploadFile>
              </FormItem>
              <FormItem label="营业执照:" prop="attachment_FJB_Length">
                <UploadFile name="营业执照" :isRegister="true" ref="UploadFileRefB" v-model="form.attachment_FJB_Length"></UploadFile>
              </FormItem>
              <FormItem label="开户许可证:" prop="attachment_FJC_Length">
                <UploadFile name="开户许可证" :isRegister="true" ref="UploadFileRefC" v-model="form.attachment_FJC_Length"></UploadFile>
              </FormItem>
              <FormItem label="主要人员:" prop="attachment_FJD_Length">
                <UploadFile name="主要人员" :isRegister="true" ref="UploadFileRefD" v-model="form.attachment_FJD_Length"></UploadFile>
              </FormItem>
              <FormItem label="主要业绩:" prop="attachment_FJE_Length">
                <UploadFile name="主要业绩" :isRegister="true" ref="UploadFileRefE" v-model="form.attachment_FJE_Length"></UploadFile>
              </FormItem>
              <FormItem>
                <Button type="primary" long size="large" style="margin-top:30px" @click="submitForm">注册</Button>
              </FormItem>
            </Form>
            <Spin fix v-if="loading">
              <Icon type="ios-loading" size=30 class="demo-spin-icon-load"></Icon>
              <div style="font-size:24px">提交中</div>
            </Spin>
          </Card>
        </Content>
        <Footer>Copyright © 2021中铁桥隧技术有限公司【苏ICP备15036412号-3】</Footer>
    </Layout>
  </div>
</template>
<script>
import UploadFile from '@/components/UpLoad'
import { userRegistration,getTypesList,isRegister } from '@/api/api'
import { validatePhone, validatemail, validatkhzh } from '@/utils/valide'
export default {
  components: {
    UploadFile
  },
  data() {
    return {
      form: {
        "apply_dept": 35,
        "attachment_FJA": "",
        "attachment_FJA_Length": 0,
        "attachment_FJA_file": [
          {}
        ],
        "attachment_FJB": "",
        "attachment_FJB_Length": 0,
        "attachment_FJB_file": [
          {}
        ],
        "attachment_FJC": "",
        "attachment_FJC_Length": 0,
        "attachment_FJC_file": [
          {}
        ],
        "attachment_FJD": "",
        "attachment_FJD_Length": 0,
        "attachment_FJD_file": [
          {}
        ],
        "attachment_FJE": "",
        "attachment_FJE_Length": 0,
        "attachment_FJE_file": [
          {}
        ],
        "email": "",
        "fileDpId": 35,
        "fileDpName": "企管部",
        "frdb": "",
        "hzqy": "",
        "hztype": "",
        types: [],
        "khh": "",
        "khzh": "",
        "lxrdh": "",
        "lxrxm": "",
        "matterName": "",
        "processType": "",
        "qyjj": "",
        "sq_yj": "",
        "startUserDpId": 35,
        "startUserDpName": "企管部",
        "startUserId": 10019,
        "startUserName": "陈秀琴",
        "zcdd": ""
      },
      queryInfo: {
        "deliveryUsers": "",
        "fileDpId": "35",
        "fileDpName": "企管部",
        "nextUserId": "",
        "nextUserNumber": "one",
        "processKey": "D0207",
        "taskId": "0",
        "userId": "10019",
        "variables": {}
      },
      formRules: {
        hzqy: { required: true, message: '请输入单位名称', trigger: 'blur' },
        types: { type:'array',required: true, message: '请输入合作类型', trigger: 'blur' },
        zcdd: { required: true, message: '请输入注册地点', trigger: 'blur' },
        frdb: { required: true, message: '请输入法人代表', trigger: 'blur' },
        lxrxm: { required: true, message: '请输入联系人姓名', trigger: 'blur' },
        lxrdh: [{ required: true, message: '请输入联系人电话', trigger: 'blur' },
        { validator: validatePhone, trigger: "blur" }],
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' },
        { validator: validatemail, trigger: "blur" }],
        khh: { required: true, message: '请输入开户行', trigger: 'blur' },
        khzh: [{ required: true, message: '请输入开户行账号', trigger: 'blur' },{ validator: validatkhzh, trigger: "blur" }],
        qyjj: { required: true, message: '请输入企业简介', trigger: 'blur' },
        sq_yj: { required: true, message: '请输入申请原因', trigger: 'blur' },
        attachment_FJB_Length: { type: 'number', min:1, required: true, message: '请上传营业执照', trigger: 'blur' },
        attachment_FJC_Length: { type: 'number', min:1, required: true, message: '请上传开户许可证', trigger: 'blur' },
        attachment_FJD_Length: { type: 'number', min:1, required: true, message: '请上传主要人员', trigger: 'blur' },
        attachment_FJE_Length: { type: 'number', min:1, required: true, message: '请上传主要业绩', trigger: 'blur' },
      },
      typeOptions: [],
      loading: false
    }
  },
  created () {
    getTypesList().then(res => { this.typeOptions = res })
  },
  methods: {
    submitForm () {
      const that = this
      const arr = ['A','B','C','D','E']
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          that.loading = true
          Promise.all(arr.map(i => this.$refs['UploadFileRef'+i].upload()))
            .then(resArr => {
              resArr.forEach((res, i) => {
                res.length && JSON.parse(res).forEach((it,index) => {
                  let obj = {}
                  obj['attachment_FJ'+arr[i]+'_realFilename_'+index] = it.realFilename
                  obj['attachment_FJ'+arr[i]+'_saveFilename_'+index] = it.saveFilename
                  obj['attachment_FJ'+arr[i]+'_relativePath_'+index] = it.relativePath
                  that.form['attachment_FJ'+arr[i]+'_file']&&that.form['attachment_FJ'+arr[i]+'_file'].push(obj)
                })
              })
              this.form.hztype = this.form.types.join(',')
              const data = Object.assign({},that.queryInfo,{variables:that.form})
              return userRegistration(data)
            })
            .then(res => {
              that.loading = false
              that.$Message.success('申请已经提交,请耐心等待!')
              that.$router.push('/')
            }).catch(err => {
              console.log(err)
              that.loading = false
            })
        } else {
          this.$Message.error('注册失败,请检查表单填写数据!')
        }
      })
    },
    validateHzqy() {
      this.form.hzqy && isRegister(this.form.hzqy).catch(err => {this.form.hzqy=""})
    }
  }
}
</script>
<style lang='scss' scoped>
  .ivu-layout {
    .ivu-layout-header {
      height: 80px;
      background: #fff;
      line-height: 80px;
      display: flex;
      justify-content: center;
      >div {
        width: 70%;
        display: flex;
        justify-content: space-between;
        div:first-child {
          img {
            vertical-align: middle;
            margin-right: 40px;
          }
          span {
            font-size: 26px;
            color: #333333;
          }
        }
        div:nth-child(2){
          font-size: 18px;
          color: #333333;
          span {
            color: #1890FF;
            &:hover {
              cursor: pointer;
              text-decoration: underline;
            }
          }
        }
      }

    }
    .ivu-layout-content {
      background: #eee;
      width: 100%;
      display: flex;
      justify-content: center;
      .ivu-card {
        width: 70%;
        margin: 50px 0;
        ::v-deep .ivu-card-body {
          display: flex;
          align-items: center;
          flex-direction: column;
          .title {
            font-size: 30px;
            color: #333333;
            line-height: 110px;
          }
          .ivu-form {
            width: 50%;
          }
        }
      }
    }
    .ivu-layout-footer {
      color: #666;
      font-size: 18px;
      background: #eee;
      text-align: center;
    }
  }
  ::v-deep .divider {
    height: 1px;
    border: 1px dashed #ddd;
    margin: 40px -120px;
  }
</style>